module.exports = __webpack_public_path__ + "img/Uberman-clock@2x.ddaeb9d1.png";